<template>
  <v-card>
    <v-card-title class="headline"
      >{{ vmd_linkSwitch ? "Link" : "Unlink" }} this product : {{ product_id}} - {{ product.product_name }}
    </v-card-title>
    <v-card-actions>
      <v-switch
        class="mx-4"
        v-model="vmd_linkSwitch"
        :label="vmd_linkSwitch ? 'Link' : 'Unlink'"
        @change="reset_linkClients"
      ></v-switch>
      <v-spacer></v-spacer>
      <v-combobox
        v-model="vmd_linkClients"
        chips
        clearable
        multiple
        solo
        :items="availiable_clients_for_select"
        :label="vmd_linkSwitch ? 'Link to client' : 'Unlink from client'"
        id="clients"
        item-text="text"
        item-value="value"
        class="custom_combobox mt-1"
        background-color="rgba(48, 127, 255, 0.1)"
      />
      <v-spacer></v-spacer>
      <v-btn
        text
        :ripple="false"
        class="ex-btn ex-primary-btn text--white mx-3"
        @click="$emit('exit_link')"
      >
        No
      </v-btn>
      <v-btn
        text
        :ripple="false"
        class="ex-btn ex-primary-btn text--white mx-3"
        @click="link_unlink_to_clients(vmd_linkSwitch)"
        :loading="loading"
      >
        Yes {{ vmd_linkSwitch ? "Link" : "Unlink" }} It
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
/* eslint-disable */
export default {
  name: "N_Link",
  props: {
    product_id: {
      type: Number,
      default: null,
      required: true,
    },
    // array with names of clients
    // store.selected_product.specs.product_clients.map(x => x.client_name)
    clients: {
      type: Array,
      default: null,
      required: true,
    },
    isLoadedProduct: {
      type: Boolean,
      default: true,
      required: false,
    }
  },
  data() {
    return {
      vmd_linkClients: [], // link v-model
      vmd_linkSwitch: true, // true = link or false = unlink
    };
  },
  computed: {
    clients_list() {
      return  this.$store.state.productionModule.clients_list.concat(
              this.$store.state.productionModule.inactive_clients
              );
    },
    availiable_clients_for_select() {
      return this.vmd_linkSwitch
        ? this.clients_list.filter((x) => !this.clients.includes(x.text))
        : this.clients_list.filter((x) => this.clients.includes(x.text));
    },
    loaded_products() {
      return this.$store.state.productionModule.loaded_products;
    },
    conflict_ids() {
      return this.$store.state.productionModule.products_ids_with_conflict;
    },
    conflict_container() {
      return this.$store.state.productionModule.conflict_temporary_data;
    },
    product() {
      return (this.isLoadedProduct)
        ? this.loaded_products.find(p => p.product_id === this.product_id)
        : (this.conflict_ids.includes(this.product_id.toString()))
          ? this.conflict_container.merge_container[0].product_conflict.product_info
          : {product_id: this.product_id, product_name: "Pes tou Panagioti na to ftiaksei"}
    },
    loading: {
      get() {
        return this.$store.state.productionModule.loading;
      },
      set(value) {
        const data = { value, key: "loading" };
        this.$store.commit("productionModule/SET_PRODUCTION_STATE", data);
      },
    },
  },
  methods: {
    // create_linked_clients() {
    //   this.clients = [...this.$store.state.productionModule.conflict_temporary_data.clients];// 1st level clone array
    // },
    reset_linkClients() {
      this.vmd_linkClients = [];
    },
    link_unlink_to_clients() {
      this.loading = true;
      // keep in [] only the client ids (vmd_linkClients.value)
      const clients_ids = this.vmd_linkClients.map((x) => x.value);
      const copied_clients = JSON.parse(JSON.stringify(this.vmd_linkClients));
      // const clients_ids = this.clients_list
      //                     .filter(x => this.vmd_linkClients.includes(x.value))
      //                     .map(x => x.value);
      console.log("selected array of clients ids", clients_ids);
      console.log("clients after map ids", this.vmd_linkClients);
      //create the payload for api
      const task = this.vmd_linkSwitch ? "linkToClients" : "unlinkFromClients";
      // const task = (this.vmd_linkSwitch) ? 'linkResolvedProduct' : 'unlinkResolvedProduct';
      const payload = {
        clients: clients_ids,
        product_ids: [
          this.product_id, // by props
        ],
      };
      console.log("send - ", { task, payload });
      this.$store
        .dispatch("productionModule/general_api", { task, payload })
        .then((res) => {
          // this.notify(`${vmd_linkSwitch ? 'Link to client' : 'Unlink from client'}`, `Client ${vmd_linkSwitch ? "link" : "unlink"}!`);
          console.log("link-unlink results", res);
          const emit_values = {
            linkSwitch: !!this.vmd_linkSwitch,
            clients: copied_clients,
          }
          console.log("link-unlink results emit_values", emit_values);
          this.$emit('success_linking', emit_values);
        })
        .catch((err) => {
          // this.$emit()
          // this.notify("Error", `Client dont ${vmd_linkSwitch ? "link" : "unlink"}!`);
        }).finally(() => this.loading = false);

      // reset values
      this.linkDialog = false;
      this.vmd_linkClients = [];
    },
    notify(title, message) {
      this.$notify({
        group: "save",
        title,
        text: message,
        duration: 500,
        speed: 600,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/production/N_Link.vue